<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">在线评估</div>
        </div>
        <div class="con">
            <div class="title">
                澳洲、新西兰大学留学评估表
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="测试题"></el-step>
                <el-step title="个人信息"></el-step>
                <el-step title="提交成功"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">提交</el-button>
            </div>

        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <!-- <p class="score">您的评分：<span>{{ totalScore }}</span>分</p> -->
                <div class="step-1">
                    <div class="input-title"><span>*</span>姓名</div>
                    <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>邮箱</div>
                    <el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
                    <div class="input-title">手机号</div>
                    <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>
                    <div class="input-title">当前所在国家/城市</div>
                    <el-input placeholder="请输入当前所在国家/城市" v-model="form.source"></el-input>
                    <div class="input-title">目标院校/专业（可填 1-3 个）</div>
                    <el-input placeholder="请输入标院校/专业" v-model="form.institution"></el-input>
                    <div class="input-title"><span>*</span>微信号</div>
                    <el-input placeholder="请输入微信号" v-model="form.wx_code"></el-input>
                    <div class="input-title">留言</div>
                    <el-input placeholder="请简要说明：目标签证/目标学校、时间计划、个人特殊情况等" v-model="form.about"></el-input>
                    <div class="input-title">附件</div>
                    <el-radio v-model="form.reportType" label="1">上传图片</el-radio>
                    <el-radio v-model="form.reportType" label="2">上传文件</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                只能上传 {{ form.reportType == 1 ? 'png、jpg' : "rar、zip、xls、xlsx、doc、docx" }} 文件
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">返回上一步</el-button>
                <el-button type="primary" class="btn" @click="subFn">提交</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                谢谢信任！您的信息已经成功提交！ <br>
                我们已收到您的评估信息。将尽快与您联系，提供初步结论和建议。 <br>
                如需加急，请在留言中标注“加急”并说明原因。新传奇签证服务团队很高兴为你服务。 <br>
                我们团队的澳洲、新西兰官方认证的注册移民代理，从业10年来，为超3万客户拿到正向结果。 <br>
                我们在悉尼，工作时间是悉尼时间早九点到晚上五点半，也欢迎添加客服微信，及时沟通。
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">重新测试</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [
                {
                    "title": "基本情况",
                    "children": [
                        {
                            "name": "申请层级",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "预科/本科" },
                                { "name": "授课型硕士" },
                                { "name": "研究型硕士" },
                                { "name": "博士" },
                                { "name": "文凭课程（VET）" }
                            ]
                        },
                        {
                            "name": "拟入学时间",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "3 个月内" },
                                { "name": "3-6 个月" },
                                { "name": "6-12 个月" },
                                { "name": "12 个月以上" },
                                { "name": "不确定" }
                            ]
                        },
                        {
                            "name": "预算（学费+生活费/年）",
                            "type": "radio",
                            "tip": "AUD为澳大利亚元",
                            "active": [],
                            "option": [
                                { "name": "AUD 3-4 万" },
                                { "name": "AUD 4-6 万" },
                                { "name": "AUD 6-8 万" },
                                { "name": "AUD 8 万以上" },
                                { "name": "不确定" }
                            ]
                        }
                    ]
                },
                {
                    "title": "学术背景",
                    "children": [
                        {
                            "name": "最高学历",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "高中/中专" },
                                { "name": "大专" },
                                { "name": "本科" },
                                { "name": "硕士" },
                                { "name": "博士" }
                            ]
                        },
                        {
                            "name": "专业背景与目标专业关系",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "同专业" },
                                { "name": "近似专业" },
                                { "name": "跨专业（可提供相关课程/项目）" }
                            ]
                        },
                        {
                            "name": "成绩/GPA",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "优秀（85%及以上）" },
                                { "name": "良好（65%及以上）" },
                                { "name": "一般（50%及以上）" },
                                { "name": "不确定/无法提供" }
                            ]
                        }
                    ]
                },
                {
                    "title": "语言与材料",
                    "children": [
                        {
                            "name": "英语水平（如有）",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "雅思 4 个 6" },
                                { "name": "雅思 4 个 7" },
                                { "name": "PTE 50-65" },
                                { "name": "PTE 65+" },
                                { "name": "无成绩/待考" }
                            ]
                        },
                        {
                            "name": "是否有拒签史",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "无" },
                                { "name": "澳洲拒签" },
                                { "name": "其他国家拒签" }
                            ]
                        },
                        {
                            "name": "是否需要打包服务",
                            "type": "checkbox",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "移民规划" },
                                { "name": "PET 英语培训" },
                                { "name": "登陆前学生租房" }
                            ]
                        }
                    ]
                },
                {
                    "title": "风险与个性化需求",
                    "children": [
                        {
                            "name": "是否有毕业后有空档期/转专业",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "无" },
                                { "name": "有（可解释）" },
                                { "name": "有（解释材料不足）" }
                            ]
                        },
                        {
                            "name": "是否计划携带家属",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "不携带" },
                                { "name": "配偶" },
                                { "name": "子女" },
                                { "name": "配偶+子女" }
                            ]
                        },
                        {
                            "name": "是否有工作经验",
                            "type": "radio",
                            "tip": "如目标为移民或特定职业发展，请在留言中说明目标行业与长期计划。",
                            "active": [],
                            "option": [
                                { "name": "无" },
                                { "name": "1-2 年" },
                                { "name": "3-5 年" },
                                { "name": "5 年以上" }
                            ]
                        }
                    ]
                }
            ],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 2,
                reportType: '2',
                source:'',
                wx_code:'',
                institution:'',

            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("只能上传一个文件");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("上传成功");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('请输入姓名')
                return
            }
            if (!this.form.email) {
                this.$message.error('请输入邮箱')
                return
            } 
            if (!this.form.wx_code) {
                this.$message.error('请输入微信号')
                return
            }
            this.$http.review_add2({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                reviewFileUrl: this.file_url,
                source: this.form.source,
                wx_code: this.form.wx_code,
                institution: this.form.institution,
            }).then(res => {
                console.log(res, '------')
                this.$message.success('提交成功')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }
        .btn {
            margin: 20px auto;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }

        .question-list:nth-child(2n) {
            border-left: 1px solid #ccc;
        }

        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/evaluateStudent.vue